import isImageAsset from "@shared/utils/isImageAsset";

export const useImgixUrlFromStoryblokMedia = () => {
  const runtimeConfig = useRuntimeConfig();
  const { storyblokSpaceId, imgixImageStoryblokUrl, imgixVideoStoryblokUrl } =
    runtimeConfig.public;

  const getImgixUrlFromStoryblokMedia = (mediaUrl: string) => {
    // do not add ?fm=mp4 if we don't have a video specific imgix url
    if (
      !isImageAsset(mediaUrl) &&
      imgixVideoStoryblokUrl !== imgixImageStoryblokUrl
    ) {
      return `${mediaUrl.replace(
        `https://a.storyblok.com/f/${storyblokSpaceId}/`,
        imgixVideoStoryblokUrl,
      )}?fm=mp4`;
    }

    return mediaUrl.replace(
      `https://a.storyblok.com/f/${storyblokSpaceId}/`,
      imgixImageStoryblokUrl,
    );
  };

  return { getImgixUrlFromStoryblokMedia };
};
